<template>
  <div class="body">
    <div class="contact">
      <div class="widthBox contactBox">
        
        <!-- <titleOne class="hidden-sm-and-up" title="Head Office -EBERS"></titleOne> -->
        <!-- <h4>CONTACT INFORMATION</h4> -->
        <!-- <div class="item">
          <span class="iconfont icon-dianhuatianchong"></span>
          <div class="cont">
            <div class="name">TEL:</div>
            <div class="tel">{{ contactInfo.phone }}</div>
          </div>
        </div> -->
        <h4>{{ contactInfo.copyright }}</h4>
        <div class="item">
          <span class="iconfont icon-wangluo"></span>
          <div class="cont">
            <div class="name">WEB:</div>
            <div class="tel">{{ contactInfo.web_url }}</div>
          </div>
        </div>
        <div class="item">
          <span class="el-icon-message"></span>
          <div class="cont">
            <div class="name">E-MAIL:</div>
            <div class="tel">{{ contactInfo.email }}</div>
          </div>
        </div>
        <h4 class=" mat100 mat10032">VIEW ROUTE</h4>
        <div class="item">
          <span class="iconfont icon-ditu-dibiao"></span>
          <div class="cont">
            <div class="name">ADD:</div>
            <div class="tel">{{ contactInfo.address }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <baidu-map
      class="map"
      ak="iItrfVQKT5urUdfSGmSEtw0aCVAj98iw"
      :zoom="15"
      :center="center"
    >
      <bm-marker
        :position="{ lng: center.lng, lat: center.lat }"
        :dragging="true"
        animation="BMAP_ANIMATION_BOUNCE"
      ></bm-marker>
    </baidu-map> -->
    <googleMap :lng="center.lng" :lat="center.lat"></googleMap>
		<div class="branch" style="border: none;">
			<titleOne class="hidden-xs-only" id="about_3" en='team introduction' title="GLOBAL MARKETING SITES"></titleOne>
			<h4 class="hidden-sm-and-up">GLOBAL MARKETING SITES</h4>
			<div class="branch-body">
				<div class="item " :style="'background: url('+item.img+');background-size: cover;background-position: center;'"  v-for="item in sub_company_list" :key="item">
					<div class="img">
						<img :src="item.nation_img" alt="">
					</div>
					<div class="txt" style="white-space: pre;">{{item.name}}</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import titleOne from "@/components/titleOne.vue";
import googleMap from "@/components/googleMap.vue";
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      sub_company_list:[]
    };
  },
  components: {
    titleOne,
    googleMap
  },
  computed: {
    contactInfo(){
      return this.$store.state.common.contact_us
    }
  },
  created() {
    this.$api.get("home/index/enterpriseIntroduction", {}).then((res) => {
      this.center.lng = res.data.contact_us.lng;
      this.center.lat = res.data.contact_us.lat;
      this.sub_company_list = res.data.sub_company
      console.log("home/index/enterpriseIntroduction---------",res)
    });
  },
  mounted () {
    
  }
};
</script>


<style lang="scss" scoped>

	.map{
	    width: 100%;
	    height: 300px;
      margin-top: 50px;
		.BMap_cpyCtrl {
		  display: none !important;
		}
		::v-deep .anchorBL {
		  display: none !important;
		}
	  }
.contactBox {
      color: #777;
  h4 {
    font-size: 36px;
    margin-top: 70px;
    &.mat10032 {
      margin-top: 70px ;
    }
  }
  .item {
    margin-top: 40px;
    .el-icon-message,
    .iconfont {
      font-size: 36px;
      font-weight: bold;
      float: left;
    }
    img {
      width: 36px;
      height: 36px;
      float: left;
    }
    .cont {
      margin-left: 86px;
      font-size: 24px;
      line-height: 40px;
      & > div {
        font-size: 24px;
        line-height: 40px;
      }
    }
  }
}
.branch{
		padding-top: 60px;
		border-top: 1px solid #1D2A55;
		margin-top: 50px;
		.branch-body{
      width: 1400px;
			margin: 0 auto;
			margin-top: 40px;
			display: flex;
			justify-content: space-between;
			align-items: center;
      flex-wrap: wrap;
      .item{
        width: 49%;
      }
		}
		h4{
			font-size: 48px;
			text-align: center;
			color: #1D2A55;
		}
		.item{
			width: 49%;
			height: 380px;
      margin-top: 20px;
      padding: 138px 90px;
      box-sizing: border-box;
			display: flex;
			align-items: center;
      .img{
        width: 210px;
        img{
          width: 210px;
          height: 110px;
        }
      }
      .txt{
        font-size: 40px;
        color: #fff;
        margin-left: 25px;
        line-break:anywhere;
        flex: 1;
      }
			.left{
				width: 40%;
				height: 100%;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.right{
				flex: 1;
				margin-left: 40px;
				p:nth-child(1){
					margin-bottom: 30px;
					font-size: 46px;
				}
				p{
					font-size: 42px;
					margin: 10px 0;
				}
			}
		}
	}

  @media screen and (max-width:1400px) {
    .branch{
			h4{
				font-size: 36px;
        text-align: center;
			}
      .branch-body{
        width: 1200px;
      }
			.item{
				// min-height: 280px;
				.left{
					width: 40%;
					height: 100%;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.right{
					p:nth-child(1){
						margin-bottom: 30px;
						font-size: 32px;
					}
					p{
						font-size: 28px;
						margin: 10px 0;
					}
				}
			}
		}
  }
  
  @media screen and (max-width:1200px) {
    .branch{
      .branch-body{
        width: 1000px;
        .item{
          padding: 100px 50px;
        }
      }
    }

  }

  
  @media screen and (max-width:1000px) {
    .branch{
      .branch-body{
        width: 100%;
        display: block;
        .item{
          padding: 100px 50px;
          width: 100%;
        }
      }
    }
  }
@media screen and (max-width:768px) {
  .contactBox .item{
    margin-top: 20px;
  }
  .branch{
    margin-top: 40px;
    padding-top: 0;
  }
  .contactBox{
    .mat10032{
      margin-top: 32px !important;
    }
  }
  .body{
    padding: 0px 16px;
    padding-top: 10px;
  }
  .widthBox {
    h4{
      margin-top: 0px !important;
    }
  }
  .branch{
			.branch-body{
				width: 100%;
        .item{
          padding: 60px 40px;
          height:auto;
          width: 100%;
          box-sizing: border-box;
          .img{
              min-width: 130px;
              // height: 73px;
              width: 38%;
            img{
              min-width: 130px;
              // height: 73px;
              width: 100%;
              object-fit: contain;
            }
          }
          .txt{
            margin-left: 10px;
            font-size: 20px;
          }
        }
			}
			h4{
				font-size: 16px;
				text-align: left;
			}
			.item{
				flex-wrap: wrap;
				padding: 0;
				border: none;
        width: 100%;
        height: auto;
				.left{
					width: 100%;
          height: calc(100vw * 0.6);
					img{
						width: 100%;
						height: 100%;
					}
				}
				.right{
					width: 100%;
					background: #F5F5F5;
					padding: 20px 12px;
					margin: 0;
					p:nth-child(1){
						color: #3E404D;
						font-size: 16px;
						margin: 0;
					}
					p{
						font-size: 12px;
						margin: 20px 0;
						color: #8A8D99;
					}
				}
			}
		}
    .widthBox {
      h4{
        font-size: 16px;
        line-height: 30px;
        margin-top: 20px;
      }
      .item{
        
        .icon-wangluo,.el-icon-message,.icon-ditu-dibiao{
          width: 20px  !important;
          height: 20px !important;
          font-size: 20px !important;
          margin-top: 4px;
        }
        .cont{
          margin-left: 30px;
          .name{
            font-size: 14px;
            line-height: 28px;
          }
          .tel{
            font-size: 14px;
            line-height: 28px;
          }
        }
      }
    }
}
</style>